import { Button, Grid, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import { PickingZoneResumeInfoDto } from './PickingValidateStart'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

interface PickingValidateZoneProps {
  pickingZoneResumeInfoDto: PickingZoneResumeInfoDto[]
  validateRoutesRelated: (pickingRouteId: number) => void
}

export const PickingValidateZoneModal: React.FC<PickingValidateZoneProps> = ({
  pickingZoneResumeInfoDto,
  validateRoutesRelated
}) => {
  return (
    <Fragment>
      <Typography variant='h5' align='center'>
        Seleccione Una Zona
      </Typography>
      <Grid
        container
        direction='row'
        spacing={1}
        justifyContent='center'
        alignItems='center'
        style={{ marginTop: '5px' }}
      >
        {pickingZoneResumeInfoDto.map((item) => (
          <Grid
            item
            xs={12}
            key={item.pickingRouteId}
            container
            spacing={1}
            direction='column'
            alignItems='center'
            justifyContent='center'
          >
            <Button
              variant='contained'
              color='primary'
              endIcon={<ArrowForwardIosIcon />}
              onClick={() => {
                validateRoutesRelated(item.pickingRouteId)
              }}
              style={{ width: '400px', marginLeft: 10, marginTop: 15 }}
            >
              {item.zoneName}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Fragment>
  )
}
